import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TableColumnMenuFilter, } from '@servicetitan/design-system';
import { DropDownList } from '@progress/kendo-react-dropdowns';
export const StandardColumnMenuFilter = (props) => (_jsx(TableColumnMenuFilter, { ...props, expanded: true }));
export function renderCustomColumnMenuFilter(FilterCell, doubleOrOptions) {
    const opts = typeof doubleOrOptions === 'boolean'
        ? { double: doubleOrOptions }
        : (doubleOrOptions !== null && doubleOrOptions !== void 0 ? doubleOrOptions : {});
    const FilterUI = ({ firstFilterProps, secondFilterProps, logicData, logicValue, onLogicChange, }) => {
        const contentStyles = {};
        if (opts.contentMaxHeight) {
            contentStyles.maxHeight = opts.contentMaxHeight;
            contentStyles.overflowY = 'auto';
        }
        return (_jsxs("div", { className: opts.contentClassName, style: contentStyles, children: [_jsx(FilterCell, { ...firstFilterProps }), !!opts.double && (_jsxs("div", { className: opts.doubleContentClassName, children: [_jsx(DropDownList, { data: logicData, value: logicValue, onChange: onLogicChange, className: "k-filter-and m-b-1", textField: "text" }), _jsx(FilterCell, { ...secondFilterProps })] }))] }));
    };
    return (props) => (_jsx(TableColumnMenuFilter, { ...props, filterUI: FilterUI, expanded: true }));
}
//# sourceMappingURL=column-menu-filters.js.map